/* eslint-disable no-underscore-dangle */
import { useState, useContext } from 'react';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { USER_FIELDS } from './userFormFields';
import { validateUserData } from './userFormValidation';

export function useUserForm() {
  const { setErrorMessage, setInfoMessage } = useContext(GeneralContext);
  const {
    NAME,
    LAST_NAME
  } = USER_FIELDS;
  const [formState, setFormState] = useState({
    [NAME]: '',
    [LAST_NAME]: '',
  });
  const [formError, setFormError] = useState({
    [NAME]: false,
    [LAST_NAME]: false,
  });
  const [initialFormState, setInitialFormState] = useState({
    [NAME]: '',
    [LAST_NAME]: '',
  });

  function resetForm() {
    setFormState(initialFormState);
    setInfoMessage('Alterações descartadas com sucesso');
  }

  function validateForm() {
    const { isValid, errors } = validateUserData(formState);
    setFormError(errors);
    if (!isValid) {
      setErrorMessage('Preencha todos os campos obrigatórios.');
    }
    return isValid;
  }

  function mapUserToFormState(user) {
    const fetchedData = {
      [NAME]: user[NAME],
      [LAST_NAME]: user[LAST_NAME],
    };
    setFormState(fetchedData);
    setInitialFormState(fetchedData);
  }

  function cleanFormState(user) {
    const fetchedData = {
      [NAME]: user[NAME],
      [LAST_NAME]: user[LAST_NAME],
    };
    setFormState(fetchedData);
  }

  return {
    formState,
    setFormState,
    formError,
    setFormError,
    setInitialFormState,
    resetForm,
    validateForm,
    mapUserToFormState,
    cleanFormState,
  };
}
